var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPictoEuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62502 10.3333C7.8471 10.3333 6.31002 9.38667 5.54502 8H9.62502L10.3334 6.66667H5.07752C5.0421 6.44667 5.02085 6.22667 5.02085 6C5.02085 5.77333 5.0421 5.55333 5.07752 5.33333H9.62502L10.3334 4H5.54502C6.31002 2.61333 7.85419 1.66667 9.62502 1.66667C10.7654 1.66667 11.8138 2.06 12.6213 2.71333L13.875 1.53333C12.7488 0.58 11.2542 0 9.62502 0C6.84835 0 4.49669 1.67333 3.61835 4H1.12502L0.416687 5.33333H3.29252C3.26419 5.55333 3.25002 5.77333 3.25002 6C3.25002 6.22667 3.26419 6.44667 3.29252 6.66667H1.12502L0.416687 8H3.61835C4.49669 10.3267 6.84835 12 9.62502 12C11.2613 12 12.7488 11.42 13.875 10.4667L12.6142 9.28667C11.8138 9.94 10.7725 10.3333 9.62502 10.3333Z",
    fill: "#1CD4FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoEuro);
export default __webpack_public_path__ + "static/media/picto-euro.a37e23720ae9508ec20a96700a6c1359.svg";
export { ForwardRef as ReactComponent };